import type { ReactElement } from "react"

export default function ProductResultBox(): ReactElement | null {
  return null
}
